import React from 'react';
export default function About() {
  return (
    <section className="py-24 px-6 bg-gray-50">
      <div className="max-w-5xl mx-auto">
        <div>
          <p className="uppercase tracking-[3px] text-[#0a8082] font-semibold mb-4">
            About Our Company
          </p>

          <h2 className="text-5xl font-bold text-[#071E56] leading-tight mb-8">
            We are Committed to Provide the Best Services to Grow Your Business
          </h2>

          <div className="space-y-8 text-gray-600 text-lg leading-9 text-justify">
            <p>
              Welcome to Praneesh Infotech, where innovation meets expertise to redefine the digital landscape. Established with a vision to revolutionize the way businesses operate, we are a dynamic startup software company committed to delivering cutting-edge solutions tailored to meet the evolving needs of our clients.
            </p>

            <p>
              At the heart of our mission is a team of passionate professionals driven by a shared commitment to excellence, creativity, and technological advancement.
            </p>

            <p>
              Our journey began with a simple yet powerful idea: to empower businesses through innovative software solutions that enhance efficiency, productivity, and overall performance.
            </p>

            <p>
              With a focus on staying ahead of the curve in a rapidly changing technological landscape, we continuously explore and embrace the latest trends to provide our clients with the most robust and scalable software applications.
            </p>

            <p>
              What sets us apart is not just our technical prowess but also our dedication to understanding the unique challenges faced by each client. We take pride in our collaborative approach, working closely with our clients to develop solutions that not only meet but exceed their expectations.
            </p>

            <p>
              Our customer-centric philosophy is embedded in every aspect of our operations, ensuring a seamless experience from project inception to delivery.
            </p>

            <p>
              As we embark on this exciting journey, we invite you to join us in shaping the future of technology. Whether you are a startup seeking a reliable technology partner or an established enterprise looking to optimize your operations, Praneesh Infotech is here to guide you towards success.
            </p>

            <div className="grid md:grid-cols-2 gap-8 pt-10">
              <div className="bg-white rounded-3xl p-8 shadow-lg border border-gray-100 hover:shadow-2xl transition duration-300">
                <div className="flex items-center gap-5 mb-6">
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-r from-[#0a8082] to-[#071E56] text-white flex items-center justify-center text-3xl shadow-lg">
                    🎯
                  </div>

                  <div>
                    <h3 className="text-3xl font-bold text-[#071E56]">
                      Our Vision
                    </h3>

                    <div className="w-16 h-1 bg-[#0a8082] rounded-full mt-3"></div>
                  </div>
                </div>

                <p className="text-gray-600 leading-8 text-lg text-justify">
                  To become a globally trusted technology partner by delivering innovative, scalable, and future-ready software solutions that empower businesses to achieve sustainable growth and digital transformation.
                </p>
              </div>

              <div className="bg-white rounded-3xl p-8 shadow-lg border border-gray-100 hover:shadow-2xl transition duration-300">
                <div className="flex items-center gap-5 mb-6">
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-r from-[#071E56] to-[#0a8082] text-white flex items-center justify-center text-3xl shadow-lg">
                    🚀
                  </div>

                  <div>
                    <h3 className="text-3xl font-bold text-[#071E56]">
                      Our Mission
                    </h3>

                    <div className="w-16 h-1 bg-[#071E56] rounded-full mt-3"></div>
                  </div>
                </div>

                <p className="text-gray-600 leading-8 text-lg text-justify">
                  Our mission is to provide high-quality software development, mobile applications, ecommerce solutions, and digital services with innovation, reliability, and customer satisfaction at the core of everything we do.
                </p>
              </div>
            </div>

            <p className="font-semibold text-[#0a8082] text-xl text-center pt-4">
              Let's build the future together!
            </p>
          </div>
        </div>

        </div>
    </section>
  );
}